import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Building2, Layers, HardHat, Mountain, Pipette, PenTool, Route, Droplets, MapPin, TestTube, Box } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { services } from '@/data/mock';
import { cn } from '@/lib/utils';

const iconMap = {
  Building2,
  Layers,
  HardHat,
  Mountain,
  Pipette,
  PenTool,
  Route,
  Droplets,
  MapPin,
  TestTube,
  Box,
};

export const ServicesSection = ({ showAll = false, className }) => {
  const displayServices = showAll ? services : services.slice(0, 6);

  return (
    <section className={cn('py-20 bg-gray-50', className)}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-red-600 font-semibold text-sm uppercase tracking-wider">What We Do</span>
          <h2 className="mt-3 text-3xl md:text-4xl font-bold text-gray-900">Our Expertise</h2>
          <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto">
            Comprehensive civil engineering services delivering excellence from concept to completion.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {displayServices.map((service, index) => {
            const IconComponent = iconMap[service.icon] || Building2;
            return (
              <Card
                key={service.id}
                className="group bg-white border-0 shadow-sm hover:shadow-xl transition-all duration-300 overflow-hidden"
                style={{ animationDelay: `${index * 50}ms` }}
              >
                <CardContent className="p-8">
                  <div className="w-14 h-14 rounded-xl bg-red-50 flex items-center justify-center mb-6 group-hover:bg-red-600 transition-colors duration-300">
                    <IconComponent className="w-7 h-7 text-red-600 group-hover:text-white transition-colors duration-300" />
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-3 group-hover:text-red-600 transition-colors">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {service.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* View All Link */}
        {!showAll && (
          <div className="text-center mt-12">
            <Link
              to="/services"
              className="inline-flex items-center gap-2 text-red-600 font-semibold hover:gap-4 transition-all duration-300"
            >
              View All Services
              <ArrowRight className="w-5 h-5" />
            </Link>
          </div>
        )}
      </div>
    </section>
  );
};

export default ServicesSection;
